import { all, call, put, takeEvery } from 'redux-saga/effects'
import { push } from 'connected-react-router'
import { addNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import api from '../../../services/api.services'
import { getErrorMsg } from '../../../common/helpers/translations'
import {
  searchCompanies,
  searchCompaniesSuccess,
  searchCompaniesFail,
  setSuperAdminTargetCompany,
  clearSuperAdminTargetCompany,
  updateSuperAdminTargetCompanyInfo,
} from './SuperAdminActions'
import { getWhoAmI } from '../../../common/auth/authActions'
import { setCompanyAdminSelectedCompanyId } from '../../CompanyAdmin/store/CompanyAdminActions'
import { setSelectedCompanyId as setStatisticsSelectedCompanyId } from '../../Statistics/store/StatisticsActions'
import { getUserCompanyCountries, getCompanyDivisions } from '../../Settings/store/SettingsActions'
import { getDivisionCategories } from '../../TeamManagement/store/TeamManagementActions'

function* sagaSearchCompanies({ payload }: any) {
  try {
    const response: any = yield call(api.auth.searchCompanies, payload)
    yield put({ type: String(searchCompaniesSuccess), payload: response })
  } catch (e: any) {
    yield put({ type: String(searchCompaniesFail) })
    const notification: INotification = {
      type: 'warning',
      content: getErrorMsg('searchCompanies'),
    }
    yield put({ type: String(addNotification), payload: notification })
  }
}

function* sagaSetTargetCompany({ payload }: any) {
  if (payload?.companyId) {
    yield put(setCompanyAdminSelectedCompanyId(payload.companyId))
    yield put(setStatisticsSelectedCompanyId(payload.companyId))
    yield put(getUserCompanyCountries({ companyId: payload.companyId }))
    yield put(getDivisionCategories({ companyId: payload.companyId }))
    yield put(getCompanyDivisions({ companyId: payload.companyId }))
    try {
      const response: any = yield call(api.auth.getCompanyInfo, { companyId: payload.companyId })
      const companyInfo = response.data || response
      yield put(
        updateSuperAdminTargetCompanyInfo({
          reportRequired: companyInfo.reportRequired,
          reportRequiredForUsers: companyInfo.reportRequiredForUsers,
          hideStatisticsView: companyInfo.hideStatisticsView,
          hideRankingView: companyInfo.hideRankingView,
          divisionRequired: companyInfo.divisionRequired,
          teamSelectionLocked: companyInfo.teamSelectionLocked,
          teamSwitchingDisabled: companyInfo.teamSwitchingDisabled,
          userCreatedTeams: companyInfo.userCreatedTeams,
          minTeamSize: companyInfo.minTeamSize,
          maxTeamSize: companyInfo.maxTeamSize,
        }),
      )
    } catch (e) {
      // Keep target as-is if fetch fails
    }
  }
}

function* sagaClearTargetCompany() {
  yield put(setCompanyAdminSelectedCompanyId(null))
  yield put(setStatisticsSelectedCompanyId(null))
  yield put(getWhoAmI())
  yield put(getUserCompanyCountries())
  yield put(getDivisionCategories())
  yield put(getCompanyDivisions())
  yield put(push('/admin/super-admin'))
}

export function* superAdminSagas() {
  yield all([
    takeEvery(String(searchCompanies), sagaSearchCompanies),
    takeEvery(String(setSuperAdminTargetCompany), sagaSetTargetCompany),
    takeEvery(String(clearSuperAdminTargetCompany), sagaClearTargetCompany),
  ])
}
